const customizedLogout = url => {
  if (url === 'deen') {
    if (!window.location.pathname.includes('signin')) {
      const redirectURL = encodeURIComponent(window.location.pathname);
      window.location.href = `/deen-sso?logout=true&redirect_url=${redirectURL}`;
    } else {
      window.location.href = `/deen-sso?logout=true`;
    }
  }
};

export default customizedLogout;
